import React from "react";
import { Row, Col, Card } from "antd";
import "./index.css";
import AddPlantCard from "./addplantCard";
import PlantInfoCard from "./plantInfoCard";
import { IoIosAddCircleOutline } from "react-icons/io";
const PlantInformation = ({
  locations,
  onChangePlantModal,
  deleteHandler,
  onHandleUpdate,
}) => {
  console.log('locationn==>', locations)
  return (
    <Row justify="center" style={{ marginTop: "20px", marginBottom: '20px' }} gutter={[0, 10]}>
      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
        <Card>
          <Row>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <h2
                className="text-left"
                style={{
                  fontSize: "20px",
                  fontWeight: "600",
                  color: "#000000",
                  marginTop: "-10px",
                  marginBottom: "10px",
                }}
              >
                Plant Information
              </h2>
            </Col>
            <Col xs={24} sm={24} md={24} lg={23} xl={23}>
              <Row justify="start" gutter={[10, 20]}>
                <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                  <AddPlantCard
                    cardIcon={<IoIosAddCircleOutline size={35} />}
                    cardText={"Add New Plant"}
                    className="ant-card-body "
                    cardStyle={{
                      height: "258px",
                      boxShadow: "0px 0px 5px 0px rgb(0 0 0 / 16%)",
                      transition: "box-shadow .25s",
                    }}
                    onChangePlantModal={onChangePlantModal}
                  />
                </Col>
                {(locations || []).map((item) => {
                  return (
                    <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                      <PlantInfoCard
                        deleteHandler={deleteHandler}
                        data={item}
                        onHandleUpdate={onHandleUpdate}
                      />
                    </Col>
                  );
                })}
              </Row>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
};
export default PlantInformation;
